module.exports = __webpack_public_path__ + "static/img/trip_logo.5bbfdc30.png";